import React, { useEffect, useRef, useState } from "react";
import MaterialTable from "material-table";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { GetTransactions } from "../../../utils/api";
import tableIcons from "../../../utils/tableIcons";
import { overlayContainer } from "../../../utils/overlayContainer";
// import Loader from "../../../components/shared/Loader";
import dayjs from "dayjs";
import {
  Popover,
  //  Select,
  //   message,
} from "antd";
// import CustomSelect from "../../ui/CustomSelect";
// import SortIcon from "../../../assets/sort.svg";
// import Spinner from "../../shared/Spinner";
import ProcessManuallyRefundModal from "./ProcessManuallyModal";
import {
  commonDateFormat,
  convertToViewableAmount,
} from "../../../utils/helper";

const ProcessManually = ({ transactionsActiveTab }) => {
  const tableRef = useRef(null);
  const [query, setQuery] = useState({
    page: 0,
    pageSize: 25,
    search: "",
    orderField: "",
    orderDirection: "",
    customFilter: "",
  });
  const [refundDetails, setRefundDetails] = useState({});

  //   const handleSortChange = (option) => {
  //     setQuery((prev) => ({ ...prev, customFilter: option, page: 0 }));
  //   };

  const handlePayManuallyClick = async (data) => {
    setRefundDetails({ visible: true, id: data.id, data: data });
  };

  const columns = [
    {
      title: "Transaction ID",
      field: "transactionId",
      sorting: true,
      cellStyle: { width: "18%" },
      render: (record) => {
        return <span>#{record?.transactionId || "--"}</span>;
      },
    },
    {
      title: "Order ID",
      field: "uniqueId",
      sorting: false,
      cellStyle: { width: "6%" },
      render: (record) => {
        return (
          <Popover
            content={
              <div className="grid grid-cols-2 grid-rows-3 gap-y-2 gap-x-4">
                <div className="flex flex-col">
                  <span className="text-xs text-[#898F95] font-medium">
                    Service Provider Name
                  </span>
                  <span className="text-xs font-semibold">
                    {record?.service?.businessProfile?.business_name}
                  </span>
                </div>
                <div className="flex flex-col">
                  <span className="text-xs text-[#898F95] font-medium text-right">
                    Service Category Name
                  </span>
                  <span className="text-xs font-semibold text-right">
                    {record?.service?.serviceCategoryName}
                  </span>
                </div>
                <div className="flex flex-col">
                  <span className="text-xs text-[#898F95] font-medium">
                    Service Name
                  </span>
                  <span className="text-xs font-semibold">
                    {record?.service?.serviceName}
                  </span>
                </div>
                <div className="flex flex-col">
                  <span className="text-xs text-[#898F95] font-medium text-right">
                    Service Cost
                  </span>
                  <span className="text-xs font-semibold text-right">
                    {convertToViewableAmount(record?.service?.price)}
                  </span>
                </div>
                <div className="flex flex-col">
                  <span className="text-xs text-[#898F95] font-medium">
                    Deposit Cost
                  </span>
                  <span className="text-xs font-semibold">
                    {convertToViewableAmount(record?.booking?.depositAmount)}
                  </span>
                </div>
                <div className="flex flex-col">
                  <span className="text-xs text-[#898F95] font-medium text-right">
                    Remaining Payment
                  </span>
                  <span className="text-xs font-semibold text-right">
                    {convertToViewableAmount(record?.booking?.remainingAmount)}
                  </span>
                </div>
              </div>
            }
            trigger="click"
          >
            <span className="cursor-pointer underline text-[#4E94DC] text-xs">
              #{record?.booking?.uniqueId}
            </span>
          </Popover>
        );
      },
    },
    {
      title: "Appointment Date",
      field: "booking.date",
      sorting: false,
      cellStyle: { width: "20%" },
      render: (record) => {
        return (
          <span>
            {commonDateFormat(record?.booking?.date)}
            {", "}
            {dayjs(`1970-01-01T${record?.booking?.startTime}`).format(
              "hh:mm a"
            )}
          </span>
        );
      },
    },
    {
      title: "Transaction Date",
      field: "createdAt",
      sorting: true,
      cellStyle: { width: "12%" },
      render: (record) => {
        return <span>{commonDateFormat(record?.createdAt)}</span>;
      },
    },
    {
      title: "Transaction Time",
      field: "createdAt",
      sorting: false,
      cellStyle: { width: "12%" },
      render: (record) => {
        return <span>{dayjs(record?.createdAt).format("hh:mm a")}</span>;
      },
    },
    {
      title: "Transaction Amount",
      field: "transactionAmount",
      sorting: false,
      cellStyle: { width: "16%" },
      render: (record) => {
        return (
          <span>{convertToViewableAmount(record?.transactionAmount)}</span>
        );
      },
    },
    {
      title: "Status",
      field: "paymentStatus",
      cellStyle: { width: "10%" },
      sorting: false,
      render: (record) => {
        return (
          <span
            className={`capitalize ${
              record?.paymentStatus === "paid"
                ? "text-[green]"
                : record?.paymentStatus === "pending"
                ? "text-yellow-500"
                : "text-red-900"
            }`}
          >
            {record?.type === "manualRefund"
              ? "Manually Refunded"
              : record?.paymentStatus}
          </span>
        );
      },
    },
    {
      sorting: false,
      align: "right",
      cellStyle: { width: "10%" },
      render: (record) => {
        return (
          <div>
            {record?.paymentStatus !== "refunded" && (
              <button
                className="text-xs font-medium text-primary-900 mr-4 flex-shrink-0 border border-primary-900 bg-primary-500 px-2 py-0.5 rounded-md"
                onClick={(e) => {
                  e.preventDefault();
                  handlePayManuallyClick(record);
                }}
              >
                Refund
              </button>
            )}
          </div>
        );
      },
    },
  ];

  const fetchData = async (dataquery) => {
    let params = "paymentStatus=paid,refunded";
    params += `&pageNo=${dataquery?.page + 1}`;
    params += `&limit=${dataquery?.pageSize}`;

    if (dataquery?.search) {
      params += `&search=${dataquery.search}`;
    }

    if (dataquery?.orderBy) {
      params += `&sort=${dataquery?.orderBy.field}&order=${dataquery?.orderDirection}`;
    }

    if (query.customFilter) {
      params += `&paymentStatus=${query.customFilter}`;
    }

    const response = await GetTransactions(params);

    return {
      data: response?.items,
      page: dataquery?.page,
      totalCount: response?.totalRecords,
    };
  };

  useEffect(() => {
    tableRef.current.onQueryChange(query);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transactionsActiveTab, query.customFilter]);

  return (
    <div className="searchposotion table-scroll poppins">
      {/* <div className="absolute -top-[87px] left-72 z-50">
        <CustomSelect
          prefixIcon={SortIcon}
          width="w-32"
          value={query.customFilter}
          onChange={(val) => handleSortChange(val)}
        >
          <Select.Option value="">All</Select.Option>
          <Select.Option value="paid">Paid</Select.Option>
          <Select.Option value="pending">Pending</Select.Option>
          <Select.Option value="failed">Failed</Select.Option>
        </CustomSelect>
      </div> */}
      <MaterialTable
        title="Completed Appointments"
        tableRef={tableRef}
        columns={columns}
        icons={tableIcons}
        page={query.page}
        options={{
          showTitle: false,
          draggable: false,
          paging: true,
          sorting: true,
          pageSize: Number(query.pageSize),
          pageSizeOptions: [10, 25, 50, 100],
          debounceInterval: 700,
          padding: "dense",
          paginationType: "stepped",
          searchFieldVariant: "outlined",
          searchFieldAlignment: "left",
        }}
        data={(query) => fetchData(query)}
        onChangeRowsPerPage={(pageSize) => {
          setQuery((prev) => ({ ...prev, pageSize: Number(pageSize) }));
        }}
        onChangePage={(page) =>
          setQuery((prev) => ({ ...prev, page: Number(page) }))
        }
        components={{
          Pagination: (props) => {
            const {
              page,
              rowsPerPage,
              count,
              onChangePage,
              onChangeRowsPerPage,
            } = props;
            return (
              <div
                className="box-shadow-pagination text-sm"
                style={{
                  position: "relative",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "10px 20px",
                  marginTop: "20px",
                }}
              >
                <div className="bottom-pagination-text">
                  <button
                    className="disabled:opacity-50"
                    onClick={(e) => {
                      onChangePage(e, page - 1);
                    }}
                    disabled={page === 0}
                  >
                    <LeftOutlined />
                  </button>
                  <span style={{ margin: "0 10px" }}>
                    {page + 1} of {Math.ceil(count / rowsPerPage)}
                  </span>
                  <button
                    className="disabled:opacity-50"
                    onClick={(e) => {
                      onChangePage(e, page + 1);
                    }}
                    disabled={
                      page === Math.ceil(count / rowsPerPage) - 1 ||
                      tableRef.current?.dataManager?.data?.length === 0
                    }
                  >
                    <RightOutlined />
                  </button>
                </div>
                <div style={{ position: "absolute", right: "25px" }}>
                  <span style={{ margin: "0 10px" }}>Items per page:</span>
                  <select
                    className="pagination-select"
                    disabled={tableRef.current?.dataManager?.data?.length === 0}
                    value={rowsPerPage}
                    onChange={(e) => {
                      onChangeRowsPerPage(e, e.target.value);
                    }}
                  >
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </select>
                </div>
              </div>
            );
          },
          OverlayLoading: () => {
            return <div style={overlayContainer}>{/* <Loader /> */}</div>;
          },
        }}
      />

      <ProcessManuallyRefundModal
        refundDetails={refundDetails}
        setRefundDetails={setRefundDetails}
        tableRef={tableRef}
      />
    </div>
  );
};

export default ProcessManually;
